import { FeatureFlags } from '@/plugins/featureFlags'

// This is really just a thin wrapper to maintain api consistency
// We would rather have users import from `@/utils` than reaching
// into configured plugins via `@/plugins/featureFlags`

export const useFeatureFlags = (): typeof FeatureFlags => {
  return FeatureFlags
}
